import type { Snapshot } from "./types";

/** Read the authority's scheduled release; rendering never starts a new timer. */
export function collapseWarningCopy(snapshot: Snapshot): string {
  if (snapshot.phase !== "combat" || snapshot.collapse_warning == null)
    return "";
  const event = [...snapshot.events]
    .reverse()
    .find(
      (event) =>
        event.kind.type === "collapse_warning" &&
        event.kind.band === snapshot.collapse_warning &&
        event.tick <= snapshot.tick &&
        typeof event.kind.release_tick === "number" &&
        Number.isFinite(event.kind.release_tick) &&
        event.kind.release_tick > snapshot.tick,
    );
  // A late join can have the active warning after its event left the bounded
  // history. Keep the sign useful without inventing a fresh four-second clock.
  if (!event || snapshot.tick_rate <= 0) return "Outer ring falls soon";
  const seconds = Math.ceil(
    (event.kind.release_tick - snapshot.tick) / snapshot.tick_rate,
  );
  return `Outer ring falls in ${seconds}s`;
}
